"use client";

import type { Metadata } from "next";
import React, { useEffect } from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FooterSticky from "@/components/FooterSticky";
import useUserAuthentication from '@/helpers/useUserAuthentication';
import usePwaStatus from "@/helpers/usePwaStatus";


export default function Template({ children }: { children: React.ReactNode }) {
    const [ isLoaded, setIsLoaded ] = React.useState(false);
    const { logIn, logOut, profile,  redirect, setDoneRedirection } = useUserAuthentication();
    const { isPWA } = usePwaStatus();
    useEffect(() => {
        setIsLoaded(true);
    }, []);

    if (!isLoaded) {
        return null;
    }

    return (
        <>
            <Header profile={profile} logIn={logIn} logOut={logOut} redirect={redirect} setDoneRedirection={setDoneRedirection} shrinkAtStartRoutes={['/game/']}/>
            <div className={`mainContainer ${isPWA ? 'is-pwa' : ''}`}>
                {children}
            </div>
           <Footer />
           <FooterSticky profile={profile} logIn={logIn} logOut={logOut} />
        </>
    );
}